import { createReducer, reducerSwitch } from 'lib/redux/reducerUtils'
import {
  BOOK_ADDON,
  FETCH_TOURV2_SNAPSHOT_DETAILS,
  SUBMIT_ORDER_TRAVELLERS,
  FETCH_PAYMENT_METHOD_STRIPE,
  USER_LOGOUT,
  SAVE_DRAFT_ORDER_TRAVELLERS,
} from 'actions/apiActionConstants'
import {
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  TOUR_TRAVELLER_DETAILS_RESET_SUBMISSION,
  UPDATE_ORDER,
} from 'actions/actionConstants'

export const initialOrderState: App.OrderState = {
  isSaveAsDraftTravellerDetails: false,
  isSubmittingTravellerDetails: false,
  travellerDetailsSubmission: null,
  travellerDetailsSubmissionError: null,
  bookingAddon: false,
  bookingAddonError: '',
  tourV2SnapshotDetails: {},
  tourV2SnapshotsLoading: {},
  tourV2SnapshotErrors: {},
  orderPaymentMethod: undefined,
  fetchingOrderPaymentMethod: false,
}

const apiRequests = reducerSwitch<App.OrderState>({
  [SUBMIT_ORDER_TRAVELLERS]: () => ({
    isSaveAsDraftTravellerDetails: false,
    isSubmittingTravellerDetails: true,
    travellerDetailsSubmission: null,
    travellerDetailsSubmissionError: null,
  }),
  [SAVE_DRAFT_ORDER_TRAVELLERS]: () => ({
    isSaveAsDraftTravellerDetails: true,
    isSubmittingTravellerDetails: true,
    travellerDetailsSubmission: null,
    travellerDetailsSubmissionError: null,
  }),
  [BOOK_ADDON]: () => ({
    bookingAddon: true,
    bookingAddonError: undefined,
  }),
  [FETCH_TOURV2_SNAPSHOT_DETAILS]: (state, action) => ({
    tourV2SnapshotsLoading: {
      ...state.tourV2SnapshotsLoading,
      [action.reservationId]: true,
    },
  }),
  [FETCH_PAYMENT_METHOD_STRIPE]: () => ({
    fetchingOrderPaymentMethod: true,
  }),
})

const apiSuccesses = reducerSwitch<App.OrderState>({
  [SUBMIT_ORDER_TRAVELLERS]: (state, action) => ({
    isSaveAsDraftTravellerDetails: false,
    isSubmittingTravellerDetails: false,
    travellerDetailsSubmission: action.data.result,
    travellerDetailsSubmissionError: null,
  }),
  [SAVE_DRAFT_ORDER_TRAVELLERS]: (state, action) => ({
    isSaveAsDraftTravellerDetails: false,
    isSubmittingTravellerDetails: false,
    travellerDetailsSubmission: action.data.result,
    travellerDetailsSubmissionError: null,
  }),
  [BOOK_ADDON]: () => ({
    bookingAddon: false,
  }),
  [USER_LOGOUT]: () => initialOrderState,
  [FETCH_TOURV2_SNAPSHOT_DETAILS]: (state, action) => ({
    tourV2SnapshotDetails: {
      ...state.tourV2SnapshotDetails,
      [action.reservationId]: action.data,
    },
    tourV2SnapshotsLoading: {
      ...state.tourV2SnapshotsLoading,
      [action.reservationId]: false,
    },
    tourV2SnapshotErrors: {
      ...state.tourV2SnapshotErrors,
      [action.reservationId]: null,
    },
  }),
  [FETCH_PAYMENT_METHOD_STRIPE]: (_state: App.OrderState, action) => ({
    fetchingOrderPaymentMethod: false,
    orderPaymentMethod: action.data,
  }),
})

const apiFailures = reducerSwitch<App.OrderState>({
  [SUBMIT_ORDER_TRAVELLERS]: (state, action) => ({
    isSaveAsDraftTravellerDetails: false,
    isSubmittingTravellerDetails: false,
    travellerDetailsSubmission: null,
    travellerDetailsSubmissionError: action.error,
  }),
  [SAVE_DRAFT_ORDER_TRAVELLERS]: (state, action) => ({
    isSaveAsDraftTravellerDetails: false,
    isSubmittingTravellerDetails: false,
    travellerDetailsSubmission: null,
    travellerDetailsSubmissionError: action.error,
  }),
  [BOOK_ADDON]: (state, action) => ({
    bookingAddon: false,
    bookingAddonError: action.error,
  }),
  [FETCH_PAYMENT_METHOD_STRIPE]: () => ({
    fetchingOrderPaymentMethod: false,
  }),
  [FETCH_TOURV2_SNAPSHOT_DETAILS]: (state, action) => ({
    tourV2SnapshotsLoading: {
      ...state.tourV2SnapshotsLoading,
      [action.reservationId]: false,
    },
    tourV2SnapshotErrors: {
      ...state.tourV2SnapshotErrors,
      [action.reservationId]: action.error,
    },
  }),
})

export default createReducer<App.OrderState>(initialOrderState, {
  [API_CALL_REQUEST]: (state, action) => apiRequests(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailures(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccesses(action.api)(state, action),
  [UPDATE_ORDER]: (state, action) => {
    if (action.order.tourItems.length) {
      const clearTourV2SnapshotDetails = { ...state.tourV2SnapshotDetails }
      for (const tourItem of action.order.tourItems) {
        if (clearTourV2SnapshotDetails[tourItem.reservationId]) {
          delete clearTourV2SnapshotDetails[tourItem.reservationId]
        }
      }
      return {
        tourV2SnapshotDetails: clearTourV2SnapshotDetails,
      }
    }
    return state
  },
  [TOUR_TRAVELLER_DETAILS_RESET_SUBMISSION]: () => ({
    travellerDetailsSubmission: null,
    travellerDetailsSubmissionError: null,
    isSubmittingTravellerDetails: undefined,
  }),
})
